import { exec } from "@kakaopay-common/payweb-core";
import { Browser } from "@kakaopay-common/user-agent";
import { INTERFACE } from "../../constants.mjs";
var BACK_MODE = /* @__PURE__ */ ((BACK_MODE2) => {
  BACK_MODE2["DEFAULT"] = "default";
  BACK_MODE2["SCRIPT"] = "script";
  BACK_MODE2["CLOSE"] = "close";
  BACK_MODE2["HIDE"] = "hide";
  return BACK_MODE2;
})(BACK_MODE || {});
let currentBackMode = "default";
function setBackEvent(callback) {
  if (typeof window === "undefined") {
    console.warn("setBackEvent can't be listened on node environement.");
    return;
  }
  window.KakaoPay.webNavigationBack = function() {
    console.log("[setBackEvent] webNavigationBack called");
    callback && callback();
  };
  if (!Browser.isKakao()) {
    showBackButtonForDev(callback);
  }
  return exec({
    command: INTERFACE.CUSTOM_NAVIGATION_BACK,
    parameters: {
      type: "script"
      /* SCRIPT */
    }
  }).then((res) => {
    if (res.success) {
      setBackMode(
        "script"
        /* SCRIPT */
      );
    }
    return res;
  });
}
function setDefaultBackEvent() {
  if (typeof window === "undefined") {
    console.warn("BackEvent can't be listened on node environement.");
    return;
  }
  delete window.KakaoPay.webNavigationBack;
  if (!Browser.isKakao()) {
    const backButton = document.querySelector("#back-button");
    if (backButton) {
      backButton.remove();
    }
  }
  return exec({
    command: INTERFACE.CUSTOM_NAVIGATION_BACK,
    parameters: {
      type: "default"
      /* DEFAULT */
    }
  }).then((res) => {
    if (res.success) {
      setBackMode(
        "close"
        /* CLOSE */
      );
    }
    return res;
  });
}
function setBackClose() {
  if (typeof window === "undefined") {
    console.warn("BackEvent can't be listened on node environement.");
    return;
  }
  if (window.history.length === 1) {
    console.log("[backEvent] doesn't need to call close.");
    return;
  }
  return exec({
    command: INTERFACE.CUSTOM_NAVIGATION_BACK,
    parameters: {
      type: "close"
      /* CLOSE */
    }
  }).then((res) => {
    if (res.success) {
      setBackMode(
        "close"
        /* CLOSE */
      );
    }
    return res;
  });
}
function setBackMode(mode) {
  currentBackMode = mode;
}
function getBackMode() {
  return currentBackMode;
}
function setBackHide() {
  if (typeof window === "undefined") {
    console.warn("setBackEvent can't be listened on node environement.");
    return;
  }
  return exec({
    command: INTERFACE.CUSTOM_NAVIGATION_BACK,
    parameters: {
      type: "hide"
      /* HIDE */
    }
  }).then((res) => {
    if (res.success) {
      setBackMode(
        "hide"
        /* HIDE */
      );
    }
    return res;
  });
}
const backButtonStyle = `
  #back-button {
    position : fixed;
    top:0px;
    width : 5rem;
    height : 5rem;
    background-color : rgba(0,0,0,0.1);
    padding : 1rem;
    border-radius : 10px;
  }
`;
const backButtonActiveRule = `
#back-button:active {
  background-color : rgba(0,0,0,0.3);
}
`;
function createBackButtonStyle() {
  const style = document.createElement("style");
  style.appendChild(document.createTextNode(""));
  document.head.appendChild(style);
  style.sheet.insertRule(backButtonStyle);
  style.sheet.insertRule(backButtonActiveRule);
}
function createBackButtonElement() {
  const backButton = document.createElement("div");
  backButton.id = "back-button";
  backButton.innerHTML = `
  <svg class="svg-icon" viewBox="0 0 20 20">
    <path fill="#000" d="M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0
    L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109
    c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483
    c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788
    S18.707,9.212,18.271,9.212z"></path>
  </svg>`;
  return backButton;
}
function getBackButton() {
  return document.querySelector("#back-button");
}
function showBackButtonForDev(callback) {
  const currentBackButton = getBackButton();
  const backButtonElement = createBackButtonElement();
  if (!currentBackButton) {
    createBackButtonStyle();
    document.body.appendChild(backButtonElement);
  } else {
    currentBackButton.replaceWith(backButtonElement);
  }
  backButtonElement.addEventListener("click", function() {
    console.log("[backEvent.ts] Back Button Emulator Clicked!");
    callback && callback();
  });
}
export {
  BACK_MODE,
  getBackMode,
  setBackClose,
  setBackEvent,
  setBackHide,
  setBackMode,
  setDefaultBackEvent
};
